<tehw0lf-nav [ngClass]="themeService.theme()"></tehw0lf-nav>
